import { render, staticRenderFns } from "./ReopenedRequests.vue?vue&type=template&id=010adaae&scoped=true"
import script from "./ReopenedRequests.vue?vue&type=script&lang=js"
export * from "./ReopenedRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010adaae",
  null
  
)

export default component.exports